import React, { useEffect, useState } from 'react';
import ModalPortal from '~/components/views/ModalPortal/ModalPortal';
import useMediaQuery from '~/hooks/use-media-query';
import { deviceMedia } from '~/styled';
import { InModalMessageProps } from '../../types';
import ModalMessageView from './ModalMessageView';

export interface ModalMessagesProps {
  modalMessage: InModalMessageProps;
  id?: string;
  testId?: string;
  containerWidth: number | null;
}

const InModalMessage = ({ modalMessage, id, testId, containerWidth }: ModalMessagesProps) => {
  const isInMediumAndMobileDevice = useMediaQuery(deviceMedia.down.s);
  const { messageId, type, title, message, icon } = modalMessage;
  const [messagePosition, setMessagePosition] = useState({
    portalId: 'action-message-container',
    position: 'bottom',
  });

  useEffect(() => {
    if (isInMediumAndMobileDevice) {
      setMessagePosition({ portalId: 'top-message-container', position: 'top' });
    } else if (containerWidth && containerWidth < 650) {
      setMessagePosition({ portalId: 'bottom-message-container', position: 'bottom' });
    } else {
      setMessagePosition({ portalId: 'action-message-container', position: 'bottom' });
    }
  }, [isInMediumAndMobileDevice, containerWidth]);

  const useOutlined = !isInMediumAndMobileDevice;

  return (
    <ModalPortal id={messagePosition.portalId}>
      <ModalMessageView
        messageId={messageId}
        type={type as any}
        position={messagePosition.position as 'top' | 'bottom'}
        icon={icon}
        useOutlined={useOutlined}
        title={title}
        message={message}
        id={id}
        testId={testId}
      />
    </ModalPortal>
  );
};

export default InModalMessage;
